// extracted by mini-css-extract-plugin
module.exports = {"button":"confirmModal_button__2OYMm"};